export class QueryModel {
  authorise_link: number;
  authorise_token: string;
  request: Query = new Query();
}
export class ForgotPasswordObject {
  forgot_password: forgotPassword = new forgotPassword();
}
export class ResetPasswordObject {
  reset_password: resetPassword = new resetPassword();
}
export class QueryModelForRouteSearch {
  authorise_link: number;
  authorise_token: string;
  search: Search = new Search();
}

export class Query {
  query: string;
  parameters: any[] = [];
  skip: boolean;
}
export class Search {
  search: string;
  parameters: any;
}

export class forgotPassword {
  user_email: string;
}

export class resetPassword {
  user_email: string;
  user_password: string;
  token: string;
}
